import { SWAPV2, SPOT, STANDARD, COMMON,COPYTRADE,CSWAP,AGENT } from '../modules'
import { commonConfig } from './common/index'
import { spotConfig } from './spot/index'
import { standardConfig } from './standard/index'
import { swapV2Config } from './swapV2/index'
import { cswapConfig } from './cswap/index'
import { copyTradeConfig } from './copyTrade/index'
import { agentConfig } from './agent/index'

export const navMenus = {
  [SWAPV2]: 'USDT-M Perp Futures',
  [CSWAP]: 'Coin-M Perp Futures',
  [SPOT]: 'Spot',
  [STANDARD]: 'Standard Futures',
  [COMMON]: 'Account & Wallet',
  [COPYTRADE]: 'Copy Trading',
  [AGENT]: 'Agent',
}

export const rootConfig = {
  [SWAPV2]: swapV2Config,
  [CSWAP]: cswapConfig,
  [COMMON]: commonConfig,
  [SPOT]: spotConfig,
  [STANDARD]: standardConfig,
  [COPYTRADE]: copyTradeConfig,
  [AGENT]: agentConfig,
}


// WEBPACK FOOTER //
// ./src/config/en-US/index.js